import React, { useMemo, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PageNotFound from "./pages/PageNotFound";
import Routes from "../Routes";
import ReactDOM from "react-dom";
import { UserContext } from "./Context/UserContext";
import Layout from "./templates/Layout";
import { FormContext } from "./Context/FormContext";
import { FlashMessageContext, } from "./Context/FlashMessageContext";
import ScrollToTop from "./atoms/ScrollToTop";
import { ThemeProvider } from "styled-components";
import { getAppTheme } from "../Services/appTheme";
import { InFormationContext } from "./Context/InFormationContext";
import { ErrorBoundary } from "../Services/bugsnag";
import Error from "./molecules/Error";
const App = () => {
    const [user, setUser] = useState(null);
    const providerValue = useMemo(() => ({ user, setUser }), [user, setUser]);
    const [dirty, setDirty] = useState(false);
    const dirtyValue = useMemo(() => ({ dirty, setDirty }), [dirty, setDirty]);
    const [flashMessage, setFlashMessage] = useState(null);
    const flashMessageValue = useMemo(() => ({ flashMessage, setFlashMessage }), [flashMessage, setFlashMessage]);
    const [inFormation, setInFormation] = useState({
        title: "",
    });
    const inFormationValue = useMemo(() => ({ inFormation, setInFormation }), [
        inFormation,
        setInFormation,
    ]);
    const appTheme = getAppTheme();
    return (React.createElement(ErrorBoundary, { FallbackComponent: Error },
        React.createElement(UserContext.Provider, { value: providerValue },
            React.createElement(InFormationContext.Provider, { value: inFormationValue },
                React.createElement(FormContext.Provider, { value: dirtyValue },
                    React.createElement(FlashMessageContext.Provider, { value: flashMessageValue },
                        React.createElement(ThemeProvider, { theme: appTheme },
                            React.createElement(BrowserRouter, null,
                                React.createElement(Layout, null,
                                    React.createElement(ScrollToTop, null,
                                        React.createElement(Switch, null,
                                            React.createElement(Route, { render: ({ location, }) => location.state &&
                                                    location.state.is404 ? (React.createElement(PageNotFound, null)) : (React.createElement(Routes, null)) }))))))))))));
};
export default App;
if (document.getElementById("app")) {
    ReactDOM.render(React.createElement(App, null), document.getElementById("app"));
}
